import { initLazy } from '../utility/lazyload';
import 'intersection-observer';


const init = async () => {
    let options = {rootMargin: "0px 0px 800px 0px"};
    const filterLink = '/api/whatwedo/filter';
    let type = $('#WhatWeDoType').val();
    let categoryIDs = [];
    let tagIDs = [];
    let APIData = [];
    const noResultContainer = `js-what-we-do-no-result`;
    const activeSearcClass = `what-we-do__search-results--active`;
    const searchResult =`js-search-results`;
    const container = `js-what-we-do-listings`;
    const containerCard = `js-what-we-do-cards`;
    const searchInput = `js-what-we-do-search`;
    const filterBtn = `js-what-we-do-filters`;
    const tagBtn = `js-what-we-do-tags`;
    const clearBtn = `js-listing-clear-all`;
    const loadMoreBtn = `js-what-we-do-loadmore`;
    let loadingEntry = '';
    let loadingObserver = '';
    let isLoadmore = false;
    let isFilter = false;
    
    let args = {
        Type: type,
        CategoryIds: categoryIDs,
        TagIds: tagIDs,
        PageIndex: 0
    }

    const ajaxCall = (link, args, callType = 'POST') => {
        APIData = [];
        $.ajax({
            type: callType,
            data: JSON.stringify(args),
            url: link,
            processData: false,
            contentType: "application/json"
        }).done(data => {
            APIData = data.data
            renderTemplate(APIData);
            initLazy.init();
            hideLoadMore(APIData);
            $(`.${loadMoreBtn}`).removeClass('loading');
            isFilter = false;
        });

    }

    const hideLoadMore = (APIData) => {
        if (APIData.length < 12) {
            $(`.loading-animation`).hide();
        }else{
            $(`.loading-animation`).show();
        }
    }

    const renderTemplate = (data) => {
        let contents = '';
        
        if(data.length > 0){
            data.map( e => {
                if ($(`.${containerCard}`).length > 0) {
                    isLoadmore ? contents = $(`.${containerCard}`).html() : '';
                    contents = contents + cardTemplate(e.linkUrl, e.title, e.imageUrl, e.linkName);
                    $(`.${containerCard}`).html(contents);
                }else {
                    contents = contents + listTemplate(e)
                    $(`.${container}`).html(contents);
                }
            })
        }else{

            contents =`
                <div style='width: 100%'>
                    <div class="title">
                        <h2>No Results Found</h2>
                        <p>Sorry, We found no results with this filter combination</p>
                    </div>
                    <div class="cta-button">
                        <a href="${window.location.pathname}" class="btn btn-outline--primary"> Clear Filter</a>
                    </div>
                    
                </div>
            `
            $(`.${container}`).html(contents);
        }
        

    }

    const searchHandler = () => {
        let searchTimeout = 0;
        $(`.${searchInput}`).on('keyup change input', (ele) => {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                const $this = ele.target;
                const keyword = $this.value;
                const APISearchLink = `/api/whatwedo/search?type=${type}&keyword=${keyword}`;

                if(keyword) {
                    $.get(APISearchLink, data => {
                        const APIData = data.data;
                        APIData.length > 0 ? searchResultHandler(APIData) : $(`.${searchResult}`).removeClass(activeSearcClass);
                    });
                } else {
                    searchResultHandler([]);
                    $(`.${searchResult}`).removeClass(activeSearcClass);
                }
                
            }, 1000);
        })
    }

    const filterBtnHandler = () => {
        $(`.${filterBtn}`).each((i, e) => {
            
            const container = $(e).closest('.what-we-do__category-link');

            container.on('click', () => {
                isLoadmore = false;
                args.PageIndex = 0;
                container.toggleClass('selected');
                window.scrollTo(0, 300);
                $(`.${containerCard}`).html('');
                $(`.${clearBtn}`).removeClass("selected");
                populateFilters();
            })
        })
    }

    const tagBtnHandler = () => {
        $(`.${tagBtn}`).each((i, e) => {

            const container = $(e).closest('.what-we-do__category-link');

            container.on('click', () => {
                isLoadmore = false;
                isFilter = true;
                container.toggleClass('selected');
                args.PageIndex = 0;
                window.scrollTo(0, 300);
                $(`.${containerCard}`).html('')
                populateFilters();
            })
        })
    }

    const clearBtnHandler = () => {
        $(`.${clearBtn}`).on('click', (event) => {
            $(`.selected`).removeClass(`selected`);
            $(event.target).closest(`.${clearBtn}`).addClass("selected");
            populateFilters();
        });
    }

    const populateFilters = () => {
        categoryIDs = [];
        tagIDs = [];
        $(`.selected`).each((i, e) => {
            let filterData = parseInt($(e).find(`.js-what-we-do-filters`).attr('data-id'));
            let tagData = $(e).find(`.js-what-we-do-tags`).attr('data-id');
            filterData ? categoryIDs.push(filterData) : null;
            tagData ? tagIDs.push(tagData) : null;
        })
        args.CategoryIds = categoryIDs;
        args.TagIds = tagIDs;      

        ajaxCall(filterLink, args);
    }

    const hasResult = () => {
        $(`.${loadMoreBtn}`).parent().css('display','block');
        $(`.${noResultContainer}`).css('display','none')
    }

    const noResult = () => {
        $(`.${loadMoreBtn}`).parent().css('display','none');
        $(`.${noResultContainer}`).css('display','block')
    }

    const searchResultHandler = (data) =>{
        $(`.${searchResult}`).addClass(activeSearcClass)
        let contents = '';
            data.map( e => {
                contents = contents + searchResultTemplate(e.linkUrl, e.linkName);
                $(`.${searchResult}`).html(`<ul>${contents}</ul>`);
            })
    }

    const searchResultTemplate = (link,title) => {
        const template = `
            <li><a href="${link.replace('~','')}">${title}</a></li>
        `
        return template
    }
    
    const listTemplate = (item) => {
        const template = `
            <li class="js-wwd-listing-item">
                <div class="what-we-do__listing">
                    <a href="${item.linkUrl.replace('~','')}">${item.linkName}</a>
                </div>
                <div class="what-we-do__listing-preview">
                    <div>
                        <h4>${item.title}</h4>
                        <p>${item.description}</p>
                        <a href="${item.linkUrl.replace("~", "")}">More <i class="ico-arrow-right"></i></a>
                    </div>
                    <img src="${item.imageUrl}" alt="${item.imageAltText}" />
                </div>
            </li>
        `;
        return template;
    }
    
    const cardTemplate = (link, title, bg, linkName) => {
        const template = `
        <div class="what-we-do__card" style="display: block;">
            <a href="${link.replace('~','')}" class="card card-image card--btn-arrow js-lazy-bg" data-bg="${bg}">
                <div class="ratio-spacer"></div>
                <div class="card__bg-image js-lazy-bg__container"></div>
                <div class="card__contents">
                    <div class="card__pretitle-container"></div>
                    <h2 class="card__title h3">${title}</h2>
                    <span class="btn card__btn">${linkName}<i class="ico-arrow-right"></i></span>
                </div>
            </a>
        </div>
        `
        return template;
    }

    const loadMoreHandler = (entry, observer) => {
            args.PageIndex = args.PageIndex + 1;
            isLoadmore = true;
            populateFilters(args);
            $(`.${loadMoreBtn}`).addClass('loading');
            loadingEntry = entry;
            loadingObserver = observer;
    }

    const handleInfiniteScroll = (entries, observer) => {
        if(!isFilter)
            entries.forEach(entry => entry.isIntersecting ? loadMoreHandler(entry.target, observer) : null)
    }

    const infiniteScroll = () => {
        const observer = new IntersectionObserver(handleInfiniteScroll,options)
        $(`.${loadMoreBtn}`).each((i, el) => observer.observe($(`.${loadMoreBtn}`)[i]))
    }

    const loadItems = () => {
        if(args.CategoryIds.length === 0) {
            $(".js-what-we-do-filters").each((i,o) => {
                let dataId = $(o).data("id");
                args.CategoryIds.push(dataId);
            })
        }
        ajaxCall(filterLink, args);
    }

    const whatWeDoListingOnClick = () => {     
        $("body").on("click", ".js-wwd-listing-item > .what-we-do__listing > a", (event) => {
            event.preventDefault();
            var $this = $(event.target);

            $this.closest("li").toggleClass("active");
        });
    }

    if ($('.js-what-we-do').length > 0) {
        setTimeout(() => { infiniteScroll(); }, 1000);
        filterBtnHandler();
        tagBtnHandler();
        clearBtnHandler();
        populateFilters();
        searchHandler();
        loadItems();
        whatWeDoListingOnClick();
    }
}


export const whatWeDoAPI = {
    init: init
};